export class DirectiveBase implements ng.IDirective {
    public restrict: string;
    public templateUrl: string | ((tElement: JQuery, tAttrs: any) => string);
    public controller: any;
    public scope: any;
    public controllerAs: string;
    public bindToController: boolean;
    public template: string;
    public transclude: boolean | any;
    // tslint:disable-next-line:no-reserved-keywords
    public require: Array<string> | string;
    public link: ng.IDirectiveLinkFn | ng.IDirectivePrePost;
    public replace: boolean;
}